import { render, staticRenderFns } from "./ordinary.vue?vue&type=template&id=64c5f0aa&scoped=true"
import script from "./ordinary.vue?vue&type=script&lang=js"
export * from "./ordinary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c5f0aa",
  null
  
)

export default component.exports